module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Next-bf8567e466a49f7499c0c763318924fc.svg";